module.exports = __webpack_public_path__ + "img/user.942a9e98.png";